import React from "react";
import {
  fetchAllBranches,
  fetchSignInToken,
  fetchSingleUser,
} from "../Dashboard/Managers/wepApiManager";
import bcrypt from "bcryptjs";
import {
  AlertDialogModel,
  EnumAlertDialogType,
  UserModel,
} from "../Dashboard/Managers/dataStructures";
import WaitingDialog, {
  AlertWaitingDialog,
} from "../Dashboard/UtilityComponents/WaitingDialog";
import { getEncryptionKey } from "../Dashboard/Managers/profileManager";
import {
  getBranchForId,
  getLanguage,
  getUserRoleObjectForKey,
  noneBranchObject,
} from "../Dashboard/Managers/dataProvider";

interface SiginInProps {
  callback: (auth_token: string, currentUser: UserModel) => void;
  onForgotPasswordHandler: () => void;
}

export default function Signin(props: SiginInProps) {
  const isEnglish = getLanguage();
  const [isActivityRunning, setIsActivityRunning] =
    React.useState<boolean>(false);
  const [userName, setUserName] = React.useState<string>("");
  const [password, setPassword] = React.useState<string>("");
  const [alertModel, setAlertModel] = React.useState<AlertDialogModel>({
    type: EnumAlertDialogType.NEUTRAL,
    alert_title: "",
    alert_description: "",
    dismiss_button_text: "",
  });

  function onSignin() {
    setIsActivityRunning(true);
    bcrypt.hash( 
      password,
      getEncryptionKey(),
      (herr: Error | null, hash: string) => {
        if (herr == null) {
          fetchSignInToken(
            userName,
            hash,
            (auth_token: string, user_id: string, role: string) => {
              setIsActivityRunning(false);
              if (auth_token != null) {
                fetchSingleUser(user_id, (cUser: UserModel) => {
                  cUser.role = getUserRoleObjectForKey(role);
                  cUser.password = hash;
                  fetchAllBranches((array_AllBranches) => {
                    let tempBranches = array_AllBranches;
                    tempBranches = [noneBranchObject(), ...tempBranches];
                    //tempBranches.push(noneBranchObject());
                    const branch = getBranchForId(
                      tempBranches,
                      cUser.permanent_branch_id
                    ); 
                    cUser.permanant_branch = branch;
                    props.callback(auth_token, cUser);
                  });
                });
              } else {
                const am: AlertDialogModel = {
                  type: EnumAlertDialogType.NEGATIVE,
                  alert_title: isEnglish
                    ? "Error Signing in "
                    : "Fehler bei der Anmeldung",
                  alert_description: isEnglish
                    ? "Please check your username and password."
                    : "Prüfen Sie bitte Ihren Benutzernamen oder Ihr Passwort.",
                  dismiss_button_text: "OK",
                };
                setAlertModel(am);
              }
            }
          );
        }
      }
    );
    //const hashPassword: string = bcrypt.hashSync(password, "xyzs");*/
  }

  function closeAlert() {
    setAlertModel({
      type: EnumAlertDialogType.NEUTRAL,
      alert_title: "",
      alert_description: "",
      dismiss_button_text: "",
    });
  }

  return (
    <div>
      <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8 bg-gray-900 h-screen">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-white">
            {isEnglish
              ? "Sign in to your account"
              : "Melden Sie sich in Ihrem Konto an"}
          </h2>
        </div>
        {alertModel.type !== EnumAlertDialogType.NEUTRAL
          ? AlertWaitingDialog(alertModel, closeAlert)
          : null}
        {isActivityRunning ? WaitingDialog() : null}

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <div className="space-y-6">
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium leading-6 text-white"
              >
                {isEnglish ? "Email address" : "E-Mail-Adresse"}
              </label>
              <div className="mt-2">
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={userName}
                  onChange={(event) => setUserName(event.target.value)}
                  autoComplete="email"
                  required
                  className="block w-full pl-2 rounded-md border-0 bg-white/5 py-1.5 text-white shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label
                  htmlFor="password"
                  className="block text-sm font-medium leading-6 text-white"
                >
                  {isEnglish ? "Password" : "Passwort"}
                </label>
                <div className="text-sm">
                  <a
                    //href="/forgot-password"
                    href="#forgot"
                    onClick={props.onForgotPasswordHandler}
                    className="font-semibold text-indigo-400 hover:text-indigo-300"
                  >
                    {isEnglish ? "Forgot password?" : "Passwort vergessen?"}
                  </a>
                </div>
              </div>
              <div className="mt-2">
                <input
                  id="password"
                  name="password"
                  type="password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  autoComplete="current-password"
                  required
                  className="block w-full pl-2 rounded-md border-0 bg-white/5 py-1.5 text-white shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                onClick={onSignin}
                className="flex w-full justify-center rounded-md bg-indigo-500 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
              >
                {isEnglish ? "Sign in" : "Anmelden"}
              </button>
            </div>
          </div>

          {/* <p className="mt-10 text-center text-sm text-gray-400">
          Not a member?
          <a
            href="#"
            className="font-semibold leading-6 text-indigo-400 hover:text-indigo-300"
          >
            Start a 14 day free trial
          </a>
        </p> */}
        </div>
      </div>
      <div className="justify-end bg-gray-900">v0.9</div>
    </div>
  );
}
